var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"join-conversation"},[_c('span',{staticClass:"line"}),_c('span',{staticClass:"text"},[_c('img',{staticClass:"img-sm mb-1 mr-2",attrs:{"src":_vm.imgAgent,"alt":""}}),_vm._v(" "+_vm._s(_vm.message.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }